import React, { Component } from 'react'
import { Button, message, Input } from 'antd';
import service from '../../../utlis/request'
export default class CourseSystem_class extends Component {
    constructor(props) {
        super(props)
        this.state = {
            // PhaseList: [{ Name: "启迪篇", ID: 1, }, { Name: "基础篇", ID: 2, }, { Name: "工具课程", ID: 3, }, { Name: "特色课程", ID: 4, }],
            ClassList: [],
            CourseID: 0,
            nav_arr: [],
            ClassName: "",
            header: 'https://api2.yuexiaojing.com/v3/'
        }

    }
    ////////////////////////////////////////////////////////////////////////
    render() {
        return (
            <div style={{ marginTop: "20px", paddingTop: "20px" }}>
                {this.state.nav_arr.length > 0 ? <div style={{ display: "flex", marginBottom: "15px", position: "relative" }}>
                    {
                        this.state.nav_arr.map((item, index) => {
                            if (index < 1) {
                                return <div key={index} onClick={() => this.switchPage(index)} style={{ marginLeft: "5px", color: "#2a2a2a", cursor: "pointer", fontSize: "18px", }}>
                                    {item.Name}
                                </div>
                            } else {
                                return <div key={index} onClick={() => this.switchPage(index)} style={{ marginLeft: "5px", color: "#2a2a2a", cursor: "pointer", fontSize: "18px", }}>
                                    <span>{">"}</span>
                                    {item.Name} </div>
                            }

                        })
                    }
                    <div style={{ position: "absolute", right: "0px", top: "0px", fontSize: "25px", color: "#239bc6", display: "flex", marginRight: "20px" }} >
                        <Input placeholder="输入名称进行搜索" style={{ width: "300px", height: "33px", borderRadius: "8px 0px 0px 8px", border: "none" }} value={this.state.ClassName} onChange={(e) => { this.setState({ ClassName: e.target.value },) }} />
                        <Button style={{ borderRadius: "0px 8px 8px 0px", height: "33px", background: "#47b3d8", color: "#fff" }} onClick={() => this.getClass()}>搜索</Button>
                    </div>
                </div> : ''}

                <div style={{ width: "100%", marginTop: "35px", display: "flex", flexWrap: "wrap" }}>
                    {
                        this.state.ClassList.map((item, index) => {
                            return <div className='liveContent' key={index} onClick={() => this.switchClass(item)} index={index} style={{ width: "280px", height: "225px", cursor: "pointer", fontSize: "18px", color: "#239bc6", background: "#fff", borderRadius: "10px", marginBottom: "30px", padding: "20px", marginRight: "20px", }}>
                                <img style={{ width: "240px", height: "135px", objectFit: "contain" }} src={this.state.header + item.Cover}></img>
                                <p style={{ height: "40px", lineHeight: "40px", textAlign: "center", fontSize: "20px" }}>{item.Name ? (item.Name.length > 10 ? item.Name.substring(0, 10) + "..." : item.Name) : ""}</p>
                            </div>
                        })
                    }
                </div>
            </div>
        )
    }
    componentDidMount() {
        this.setState({ CourseID: this.props.CourseItem.ID, nav_arr: this.props.nav_arr }, () => {
            this.getClass()
        })

    }
    getClass() {
        service.request({
            method: 'get',
            url: service.api.homeURL + '/class',
            params: {
                offset: 0,
                limit: 0,
                name: this.state.ClassName,
                courseID: this.state.CourseID
            }
        }).then(res => {
            if (res.code === 200) {
                this.setState({
                    ClassList: res.data,
                }, () => {
                    if (this.state.ClassList.length <= 0) {
                        message.error("该课程下无此条课时")
                    }
                })
            } else {
            }
        })
    }
    switchPage(index) {
        if (index == 0) {
            var arr = []
            arr.push(this.state.nav_arr[index])
            this.props.setPage(1, arr)
        } else if (index == 1) {
            //
            var arr = []
            arr.push(this.state.nav_arr[0])
            this.props.setPage(1, arr)
        }

    }
    switchClass(item) {
        this.state.nav_arr.push(item)
        this.setState({}, () => {
            this.props.setPage(5, this.state.nav_arr)
            this.props.setClass(item)
        })

    }
    // 鼠标事件
    enter(ID, index) {
        if ((index + 1) % 4 == 1) {
            var doc = document.getElementById(ID)
            doc.style.border = "2px solid #492bce"
            // e.target.style.background = "#bfecd7"
        }
        if ((index + 1) % 4 == 2) {
            var doc = document.getElementById(ID)
            doc.style.border = "2px solid #22d9e6"
            // e.target.style.background = "#bfecd7"
        }
        if ((index + 1) % 4 == 3) {
            var doc = document.getElementById(ID)
            doc.style.border = "2px solid #73f909"
            // e.target.style.background = "#bfecd7"
        }
        if ((index + 1) % 4 == 4) {
            var doc = document.getElementById(ID)
            doc.style.border = "2px solid #976c05"
            // e.target.style.background = "#bfecd7"
        }
    }
    remove(ID, index) {
        var doc = document.getElementById(ID)
        doc.style.border = "2px solid #fff"
        // e.target.style.background = 'none'
    }
}